import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { RouterModule } from '@angular/router';

import { SharedUiModule } from '@digital-platform/shared/ui';
import { SharedUiMaterialModule } from '@digital-platform/shared/ui-material';
import { UsersUiModule } from '@digital-platform/users/ui';
import { AddGeneratorFormComponent } from './add-generator-form/add-generator-form.component';
import { GeneratorBillingDisplayComponent } from './generator-billing-display/generator-billing-display.component';
import { GeneratorBillingFormComponent } from './generator-billing-form/generator-billing-form.component';
import { GeneratorDisplayComponent } from './generator-display/generator-display.component';
import { GeneratorSelectComponent } from './generator-select/generator-select.component';
import { GeneratorTableComponent } from './generator-table/generator-table.component';
import { GeneratorThirdPartyQuestionsComponent } from './generator-third-party-questions/generator-third-party-questions.component';
import { SubmittedSplashComponent } from './submitted-splash/submitted-splash.component';
import { UpdatedGeneratorBannerComponent } from './updated-generator-banner/updated-generator-banner.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([]),
    ReactiveFormsModule,
    SharedUiMaterialModule,
    SharedUiModule,
    UsersUiModule,
    MatPaginatorModule,
  ],
  exports: [
    GeneratorBillingDisplayComponent,
    GeneratorDisplayComponent,
    GeneratorSelectComponent,
    AddGeneratorFormComponent,
    GeneratorBillingFormComponent,
    GeneratorTableComponent,
    SubmittedSplashComponent,
    GeneratorThirdPartyQuestionsComponent,
    UpdatedGeneratorBannerComponent,
    MatIconModule,
  ],
  declarations: [
    GeneratorBillingDisplayComponent,
    GeneratorDisplayComponent,
    GeneratorSelectComponent,
    AddGeneratorFormComponent,
    GeneratorBillingFormComponent,
    GeneratorTableComponent,
    SubmittedSplashComponent,
    GeneratorThirdPartyQuestionsComponent,
    UpdatedGeneratorBannerComponent,
  ],
})
export class GeneratorsUiModule {}
